import axios from "../axiosPlugin.js";

export const getMailingListService = data => {
  return axios({
    url: "/api/cl/mailing/list",
    method: "get",
    data: {
      data,
    },
  });
}

export const createMailingService = data => {
  return axios({
    url: "/api/cl/mailing/create",
    method: "post",
    data: {
      data,
    },
  });
}

export const getMailingDetailService = data => {
  return axios({
    url: `/api/cl/mailing/detail/${data.id}`,
    method: "get",
    data: {},
  });
}

export const updateMailingService = data => {
  return axios({
    url: "/api/cl/mailing/update",
    method: "put",
    data: {
      data,
    },
  });
}

export const deleteMailingService = data => {
  return axios({
    url: `/api/cl/mailing/delete/${data.id}`,
    method: "delete",
    data: {},
  });
}

export const getMemberCountService = data => {
  return axios({
    url: "/api/cl/mailing/member-count",
    method: "post",
    data: {
      data,
    },
  });
}

export const exportMembersService = id => {
  return axios({
    url: `/api/cl/mailing/export-members/${id}`,
    method: "get",
    data: {},
  });
}